import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import RecipesComponent from './Component';
import RecipesRecipe from './Recipe';

const RecipePortionComponent = ApplicationRecord.extend({
  attrs: {
    amount_to_eat: attr({ type: Number }),
    component: belongsTo({ type: RecipesComponent, persist: false }),
    component_id: attr({ type: Number }),
    portion_count_per_meal: attr({ type: Number }),
    recipe: belongsTo({ type: RecipesRecipe, persist: false }),
    recipe_id: attr({ type: Number }),
    quantity: attr({ type: Number }),
    display_title: attr({ type: String, persist: false }),
    recipe_step_id: attr({ type: Number, persist: false }),
    position: attr({ type: Number }),
  },
  static: {
    jsonapiType: 'recipes-recipe_portion_components',
  },
  methods: {
    price() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.quantity === 'undefined') {
        return undefined;
      }
      return parseFloat((this.quantity * this.component.price).toFixed(2));
    },
    protein() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.protein());
    },
    fat() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.fat());
    },
    carbohydrates() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.carbohydrates());
    },
    calories() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.calories());
    },
    sugars() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.sugars());
    },
    salt() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.salt());
    },
    fibre() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.fibre());
    },
    saturated_fat() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.saturated_fat());
    },
    volume() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.quantity === 'undefined') {
        return undefined;
      }
      if (this.component.volume() === 0) {
        return undefined;
      }
      if (this.component.requireCoolBag()) {
        return 'N/A';
      }
      // volume is cubic mm, convert to cubic cm and round up to nearest integer
      return Math.ceil((this.quantity * this.component.volume()) / 1000);
    },
    weight() {
      if (!this.component) {
        return undefined;
      }
      if (typeof this.amount_to_eat === 'undefined') {
        return undefined;
      }
      return this.maxOneDecimal(this.amount_to_eat * this.component.averageWeight());
    },
    maxOneDecimal(value) {
      return parseFloat(value.toFixed(1));
    },
  },
});

export default RecipePortionComponent;
